import axios from 'axios'
import { CommonDeviceParams, CommonDeviceResponse } from '@/api/services/common/device/common-device.dto'

class CommonDeviceService {
    async search(laboratoryId: number, params?: CommonDeviceParams): Promise<CommonDeviceResponse[]> {
        const response = await axios.get<CommonDeviceResponse[]>(`/common/laboratories/${laboratoryId}/devices/search`, { params })
        return response.data
    }
}

export const commonDeviceService = new CommonDeviceService()
